import { ReactElement } from 'react';
import { DatasetDetailsImagesContainer } from '../../../modules/datasets/containers/DatasetDetailsImages.container';

export const DatasetDetailsImagesView = (): ReactElement => <DatasetDetailsImagesContainer />;
